import Presentation from "./presentation";

const Tabs = ( { activeTab, onChange, list, variant } ) => {

	return (
		<Presentation
			activeTab = { activeTab }
			list      = { list }
			onChange  = { onChange }
			variant   = { variant }
		/>
	);
};

export default Tabs;